<template>
     <!-- navbar -->
     <nav class="navbar navbar-expand-lg navbar-light" style="background-color:transparent; ">
        <a class="navbar-brand " href="/" style="color: #ffffff;">
        <!-- <img :src="getImage()"  alt=""  width="50%"/> -->
        <img :src="'/imgs/tallyLogo4.png'" class="img-fluid img_size" alt="" >
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                    <!--<a v-bind:href =" url('/') " class="nav-link home-nav-link  nav-link-header">Home</a> -->
                    <a href="/" class="nav-link home-nav-link nav-link-header">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/support">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Pricing
                        </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Blog</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Faq's</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Support</a>
                </li>
            </ul>
        </div> 

        <div class="collapse navbar-collapse " id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <div class="flex justify-between mr-4">
              <div class="flex justify-between space-x-2">
                <img :src="'/imgs/tally_header.png'" class="img-fluid " alt="" >
                  <div class="flex flex-col ml-2">
                    <div>
                      <h6 class=" text-xs font-semibold text-gray-400" >
                          hotline 24/7
                      </h6>
                    </div>
                  <div>
                    <h6 class=" text-xs text-gray-700 font-bold">
                        (+91)9263637575
                    </h6>
                  </div>
                          
                </div>
              </div>
              </div> 
            </ul>
             <button type="button" id="button" class=" md:py-1 py-1 mr-2 px-3 rounded-md  text-white" style="background-color: #07528E;">Get Free</button>     
        </div> 
  </nav>
    <!-- navbar --> 

    <!--BLOG SECTION-->
<div class="blog_container">
<div class="blog_content">
<div class="left_content">
<!--CARD BEGINING-->
<div class="blog_card">
<a href="article.html" class="figure">
<img :src="'/imgs/banner.png'" class="img-fluid" alt="" loading="lazy" >
<span class="tag">15 JAN</span>
</a>
<section>
<!-- <a href="article.html" class="title">Blog title goes here...</a> -->
<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>
            <h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1>
            <p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p>
            <div class="flex items-center flex-wrap">
              <a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                &rarr;
              </a>
              <span class="text-gray-400 mr-3 items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>1.2K
              </span>
              <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                </svg>6
              </span>
            </div>
</section>
</div>
<!--CARD ENDS-->
<!--CARD BEGINING-->
<div class="blog_card">
<a href="#" class="figure">
    <img :src="'/imgs/screen2.png'" class="img-fluid" alt="" loading="lazy" >
<!-- <img src="https://i.postimg.cc/KcwkZQsx/dummy.png" alt="" loading="lazy"> -->
<span class="tag">15 JAN</span>
</a>
<section>
<!-- <a href="article.html" class="title">Blog title goes here...</a> -->
<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>
            <h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1>
            <p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p>
            <div class="flex items-center flex-wrap ">
              <a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                &rarr;
              </a>
              <span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>1.2K
              </span>
              <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                </svg>6
              </span>
            </div>
</section>
</div>
<!--CARD ENDS-->
<!--CARD BEGINING-->
<div class="blog_card">
<a href="article.html" class="figure">
    <img :src="'/imgs/screen2.png'" class="img-fluid" alt="" loading="lazy" >
<span class="tag">15 JAN</span>
</a>
<section>
<!-- <a href="article.html" class="title">Blog title goes here...</a> -->
<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>
            <h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1>
            <p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p>
            <div class="flex items-center flex-wrap ">
              <a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                &rarr;
              </a>
              <span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>1.2K
              </span>
              <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                </svg>6
              </span>
            </div>
</section>
</div>
<!--CARD ENDS-->
<!--CARD BEGINING-->
<div class="blog_card">
<a href="article.html" class="figure">
    <img :src="'/imgs/screen2.png'" class="img-fluid" alt="" loading="lazy">
<span class="tag">15 JAN</span>
</a>
<section>
<!-- <a href="article.html" class="title">Blog title goes here...</a> -->
<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>
            <h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1>
            <p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p>
            <div class="flex items-center flex-wrap ">
              <a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                &rarr;
              </a>
              <span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>1.2K
              </span>
              <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                </svg>6
              </span>
            </div>
</section>
</div>
<!--CARD ENDS-->
<!--CARD BEGINING-->
<div class="blog_card">
<a href="article.html" class="figure">
    <img :src="'/imgs/screen2.png'" class="img-fluid" alt="" loading="lazy">
<span class="tag">15 JAN</span>
</a>
<section>
<!-- <a href="article.html" class="title">Blog title goes here...</a> -->
<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>
            <h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1>
            <p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p>
            <div class="flex items-center flex-wrap ">
              <a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                &rarr;
              </a>
              <span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>1.2K
              </span>
              <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                </svg>6
              </span>
            </div>
</section>
</div>
<!--CARD ENDS-->
<!--CARD BEGINING-->
<div class="blog_card">
<a href="#" class="figure">
    <img :src="'/imgs/screen2.png'" class="img-fluid" alt="" loading="lazy">
<!-- <img src="https://i.postimg.cc/KcwkZQsx/dummy.png" alt="" loading="lazy"> -->
<span class="tag">15 JAN</span>
</a>
<section>
<!-- <a href="article.html" class="title">Blog title goes here...</a> -->
<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>
            <h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1>
            <p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p>
            <div class="flex items-center flex-wrap ">
              <a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                &rarr;
              </a>
              <span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>1.2K
              </span>
              <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                </svg>6
              </span>
            </div>
</section>
</div>
<!--CARD ENDS-->
<!--CARD BEGINING-->
<div class="blog_card">
<a href="#" class="figure">
    <img :src="'/imgs/screen2.png'" class="img-fluid" alt="" loading="lazy">
<span class="tag">15 JAN</span>
</a>
<section>
<!-- <a href="article.html" class="title">Blog title goes here...</a> -->
<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>
            <h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1>
            <p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p>
            <div class="flex items-center flex-wrap ">
              <a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                &rarr;
              </a>
              <span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>1.2K
              </span>
              <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                </svg>6
              </span>
            </div>
</section>
</div>
<!--CARD ENDS-->
</div>
<button class="btn1 load-btn">Load more</button>
</div>

<div class="blog_content right_content">
<!--SEARCH COLUMN BEGINING-->
<div class="columns search_column">
<section class="search">
<form>
<fieldset><input type="text" name="search" placeholder="Search..." maxlength="100" required=""></fieldset>
<fieldset><button type="submit" class="btn1"><i class="fa fa-search"></i></button></fieldset>
</form>
</section>
</div>
<!--SEARCH COLUMN ENDS-->
<!--BOOKS COLUMN BEGINING-->
<div class="columns books">
<span class="title">New Books <a href="#" title="Explore More"><i class="fa fa-share"></i></a></span>
<section>
<div class="cards">
<div class="card_part card_part-one" style="background-image: url(/imgs/img_training.png)"></div>
<div class="card_part card_part-two" style="background-image: url(/imgs/ic_paytime_2.png);"></div>
<div class="card_part card_part-three" style="background-image: url(/imgs/img_training.png);"></div>
<div class="card_part card_part-four" style="background-image: url(/imgs/ic_paytime_2.png);"></div>
</div>
</section>
</div>
<!--BOOKS COLUMN ENDS-->
<!--CATEGORIES COLUMN BEGINING-->
<div class="columns categories">
<span class="title">Categories</span>
<section>
<a href="#">aruvaa</a> 
<a href="#">tallyclinic</a>
<a href="#">Importance of reading</a>
<a href="#">Origin of vedas</a>
<a href="#">Addons</a>
<a href="#">modules</a>
<a href="#">Process of aquiring knowledge</a>
</section>
</div>
<!--CATEGORIES COLUMN ENDS-->
<!--POSTS COLUMN BEGINING-->
<div class="columns posts">
<span class="title">Recent Posts <a href="#" title="Explore More"><i class="fa fa-share"></i></a></span>
<section>
<a href="#"><img src="https://i.postimg.cc/KcwkZQsx/dummy.png" alt="" loading="lazy"> <p>Be brave, be strong, be bold. Man dies but once. </p></a>
<a href="#"><img src="https://i.postimg.cc/KcwkZQsx/dummy.png" alt="" loading="lazy"> <p>Be brave, be strong, be bold. Man dies but once. </p></a>
<a href="#"><img src="https://i.postimg.cc/KcwkZQsx/dummy.png" alt="" loading="lazy"> <p>Be brave, be strong, be bold. Man dies but once. </p></a>
</section>
</div>
<!--POSTS COLUMN ENDS-->
<!--COMMENTS COLUMN BEGINING-->
<div class="columns comments">
<span class="title"> Recent Comments <a href="#" title="Explore More"><i class="fa fa-share"></i></a></span>
<section>
<marquee direction="up" scrollamount="4" onMouseOver="this.stop()" onMouseOut="this.start()" class="marquee2">
<p>Remember, torn clothes should not be left at home. Dispose of them out. Buying new clothes like towels.</p> 
<p>wearing clothes, bedsheets are like inviting good luck to the home.</p>
<p>Arrange doormats before every door and please change the doormats once in 6/8 months or maximum within 1 year. For More Daily</p>
</marquee>
</section>
</div>
<!--COMMENTS COLUMN ENDS-->
<!--SOCIAL MEDIA ICONS BEGINING-->
<div class="columns social_icons">
<a href="#" title="Facebook"><i class="fa fa-facebook"></i></a>
<a href="#" title="Instagram"><i class="fa fa-instagram"></i></a>
<a href="#" title="Youtube"><i class="fa fa-youtube"></i></a>
<a href="#" title="Whatsapp"><i class="fa fa-whatsapp"></i></a>
<a href="#" title="Telegram"><i class="fa fa-telegram"></i></a>
</div>
<!--SOCIAL MEDIA ICONS ENDS-->
</div>
</div>


  <!-- footer start -->
  <div>
        <footer class="section bg-footer section-main-container">
          <div class="container">
              <div class="row">
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Get our app</h6>
  
                          <div class="">
                              <a href=""><img
                                      src="/imgs/gp.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                              <a href=""> <img
                                      src="/imgs/gp2.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                          </div>
                      </div>
                  </div>
  
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Resources</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-2">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Help</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-4">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Contact Us</h6>
                          <table>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-envelope contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; abc@aruvaa.com</p>
                                  </td>
                              </tr>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-mobile-alt contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; +01 123-456-7890</p>
                                  </td>
                              </tr>
                          </table>
  
   </div>
                  </div>
  
              </div>
          </div>
  
          <div class="text-center mt-5 container">
              <hr class="footer-hr">
              <div class="d-flex justify-content-center below-hr-container">
                  <a href=""><span>Privary Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Terms of use</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Cookie Privacy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Abuse Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Anti-spam Policy</span></a>
              </div>
              <p class="footer-alt mb-0 f-14 mt-2">2019 © Aruvaa, All Rights Reserved</p>
          </div>
      </footer>
    </div>
    <!-- footer end -->
</template>

<script>

</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}
h6{
margin-bottom: 0.1rem;
}
.img_size{
 height: auto;
 width: 156px;
}
.nav-link-header {
     color: #9c761f !important;
     font-weight: 650 !important;
     font-size: 16px;
 }
 .navbar {
  position: relative;
  display: flex;
  align-items: center; 
  padding: .5rem 5rem;
}
@media  only screen and (max-width: 758px) {
    .navbar {
  padding: .5rem 1rem;
}
      }
      @media only screen and (max-width: 992px) {
    .navbar {
  padding: .5rem 1rem;
}
  }

  *, *:after, *:before {
-webkit-box-sizing: border-box;
-moz-box-sizing: border-box;
box-sizing: border-box;
}

:root{
scrollbar-color: rgb(210,210,210) rgb(46,54,69) !important;
scrollbar-width: thin !important;
--white:#fff;
--black:#000;
--dark:#2a2a2e;
--yellow:#f7b500;
--darkyellow:#f79300;
--red:#fe3e30;
--darkred:#f72729;
--blue:#2588cf;
--darkblue:#026dbe;
--defaultfont:'Poppins', sans-serif;
--titlefont:'Roboto', sans-serif;
}

::-webkit-scrollbar {
height: 12px;
width: 6px;
background: var(--dark);
}

::-webkit-scrollbar-thumb {
background: var(--dark);
-webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
}

::-webkit-scrollbar-corner {
background: var(--dark);
}


/********************************
          DEFAULT
*********************************/
/* body{
margin:0;
overflow-x:hidden !important;
font-family:var(--defaultfont);
} */

a{
text-decoration:none;
color:inherit;
}

a, button, input, select, p{
outline:none !important;
transition:0.5s;
} 

em{
font-style:normal;
color:var(--primary);
}

p{
line-height:1.6em;
font-size:14px;
color:rgba(1,1,1,0.7);
}

/* img{
max-width:100%;
} */

figure{
margin:0;
padding:0;
}

fieldset{
width:100%;
border:0;
padding:0;
margin:0;
}

.title{
font-family:var(--titlefont);
}

.btn1, .btn2{
padding:1rem 2rem;
border-radius:10px;
text-align:center;
border:0;
}

.btn1{
background-color:var(--yellow);
color:var(--white);
}

.btn1:hover{
background-color:var(--darkyellow);
}

.btn2{
background-color:var(--red);
color:var(--white);
}

.btn2:hover{
background-color:var(--darkred);
}



/********************************
        BLOG CONTAINER
*********************************/
.blog_container{
width:100%;
display:flex;
align-items:top;
background-color:#f1f1f1;
}

/*BLOG LEFT CONTENT*/
.blog_content{
padding:2rem;
width:100%;
}

.blog_content .load-btn{
display:block;
width:150px;
margin:5vh auto;
}

.left_content{
display:flex;
align-items:top;
justify-content: space-between;
flex-wrap:wrap;
column-count: 2;
gap: 20px 10px;
flex:0 0 70%;
}

.right_content{
flex:0 0 30%;

}

.blog_card{
width:100%;
flex:0 0 48.5%;
overflow:hidden;
background-color:var(--white);
}

.blog_card:nth-child(1){
flex:0 0 100%;
}

.blog_card .figure{
display:block;
width:100%;
height:200px;
position:relative;
overflow:hidden;
}

.blog_card:nth-child(1) .figure{
height:300px;
}

.blog_card .figure img{
width:100%;
height:100%;
object-fit:cover;
transition:0.5s;
}

.blog_card .tag{
padding:5px 10px;
background-color:var(--yellow);
color:var(--white);
position:absolute;
right:1%;
top:3%;
font-size:12px;
}

.blog_card section{
padding:1rem;
position:relative;
background-color:var(--white);
}

.blog_card section .title{
font-weight:600;
font-size:18px;
color:var(--dark);
width:auto;
}

.blog_card section a:hover{
color:var(--yellow);
}

.blog_card:hover > .figure img{
transform:scale(1.02);
}

.share_icon{
position:absolute;
bottom:-30px;
left:10px;
background-color:var(--red);
color:var(--white);
display:flex;
align-items:center;
padding-right:5px;
font-size:13px;
cursor:pointer;
transition:0.5s;
}

.share_icon .fa{
padding:5px;
background-color:var(--darkred);
margin-right:10px;
}

.blog_card section img{
width:30%;
margin-right:20px;
object-fit:cover;
border:5px solid rgba(1,1,1,0.1);
}

.blog_card section img:nth-child(even){
float:left;
}

.blog_card section img:nth-child(odd){
float:right;
}




/*BLOG RIGHT CONTENT*/
.columns{
display:block;
margin-bottom:4vh;
background-color:var(--white);
}

.columns section{
padding:1rem;
}

.columns .title{
background-color:var(--yellow);
color:var(--white);
padding:1rem;
text-align:left;
width:100%;
display:block;
transition:0.2s;
border-left:0px solid #07528E;
}

.columns:hover > .title{
border-left:5px solid #07528E;
}

.columns .title a{
float:right;
}

.columns .title a:hover{
color:#07528E;
}

.search form{
width:85%;
display:flex;
align-items:center;
}

.search fieldset:nth-child(2){
width:10%;
}

.search form input{
border:1px solid rgba(1,1,1,0.1);
padding:1rem;
width:100%;
font-weight:600;
color:rgba(1,1,1,0.5);
}

.search .btn1{
border:1px solid var(--yellow);
border-radius:0;
}



/*BOOKS*/
.books .cards {
position: relative;
width: 100%;
height:46vh;
overflow: hidden;
border-radius: 5px;
background-color:#f1f1f1;
}

.books .cards::after {
content: '';
position: absolute;
left: 0;
top: 0;
z-index: 900;
display: block;
width: 100%;
height: 100%;
}

.books .card_part {
position: absolute;
top: 0;
left: 0;
z-index: 7;
display: flex;
align-items: center;
width: 100%;
height: 100%;
background-size:100% 100%;
background-position:center;
transform: translateX( 700px );
background-repeat:no-repeat;
animation: opaqTransition 28s cubic-bezier(0, 0, 0, 0.97) infinite;
background-color:#f1f1f1;
}

.books .card_part.card_part-two {
z-index: 6;
animation-delay: 7s;
background-repeat:no-repeat;
}

.books .card_part.card_part-three {
z-index: 5;
animation-delay: 14s;
background-repeat:no-repeat;
}

.books .card_part.card_part-four {
z-index: 4;
animation-delay: 21s;
background-repeat:no-repeat;
}

@keyframes opaqTransition {
3% { transform: translateX( 0 ); }
25% { transform: translateX( 0 ); }
28% { transform: translateX( -700px ); }
100% { transform: translateX( -700px ); }
}


/*CATEGORIES*/
.categories a{
display:inline-block;
padding:0.2rem 1rem;
border-radius:40px;
background-color:#07528E;
margin:5px 3px;
font-size:12px;
white-space:nowrap;
color:var(--white);
}

.categories a:hover{
background-color:var(--dark);
}


/*POSTS*/
.posts a{
display:flex;
align-items:center;
margin:0.4rem 0;
}

.posts a img{
width:100px;
margin-right:10px;
}

.posts a:hover > p{
color:var(--black);
}

/*COMMENTS*/
.comments{
position:relative;
overflow:hidden;
max-height:60vh;
}

.marquee2 {
position: relative;
overflow:hidden;
line-height:1.6em;
}

.marquee2 p{
border-bottom:1px solid rgba(1,1,1,0.1);
position:relative;
padding:0.4rem 0;
}

.marquee2 p:before{
content:"\f10d";
font-family:"FontAwesome";
margin-right:5px;
position:relative;
top:-5px;
}

@keyframes marquee1 {
0% {
top: 10%;
}
100% {
top: -100%;
}
}

/*SOCIAL MEDIA*/
.social_icons{
display:flex;
align-items:center;
justify-content:center;
column-gap: 15px;
background-color:transparent;
}

.social_icons .fa{
padding:7px 13px;
background-color:#f1f1f1;
color:var(--white);
transition:0.2s;
}

.social_icons a:hover > .fa{
transform:scale(1.1);
}

.social_icons .fa-facebook{
background-color:#3b5998;
}

.social_icons .fa-instagram{
background-color:#fb3958;
}

.social_icons .fa-youtube{
background-color:#c4302b;
}

.social_icons .fa-whatsapp{
background-color:#25d366;
}

.social_icons .fa-telegram{
background-color:#3399ff;
}

@media (max-width:1000px){
.blog_container{
flex-wrap:wrap;
}
.blog_content{
padding:0;
order:2;
}
.left_content{
flex:0 0 100%;
order:2;
padding:1rem;
}
.right_content{
flex:0 0 100%;
order:1;
padding:1rem;
}
.books,.posts, .comments, .categories{
display:inline-block;
width:47%;
margin:1.3%;
margin-bottom:0;
vertical-align:top;
height:63vh;
}
.posts{
overflow-y:auto;
}
.right_content{
flex:0 0 100%;
}
}

@media (max-width:740px){
.blog_card{
flex:0 0 100%;
}
.posts, .comments, .books, .categories{
width:100%;
margin:0;
height:auto;
margin-bottom:4vh;
}
}

/* faq's css start */
.accordion__item {
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  /* box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.06); */
}
.accordion__body {
  display: none;
  padding-top: 10px;
}
.accordion__body p {
  margin-bottom: 0;
}
.accordion__title {
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 0;
  position: relative;
}
.accordion__title:after {
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
  background: url("/imgs/arrow.png");
  /* background-size: 20px; */
}
.accordion__title.active {
  color: #07528e;
}
.accordion__title.active:after {
  transform: rotate(-180deg);
}
/* footer css start */
.bg-footer {
          background-color: #33383c;
          padding: 50px 0 30px;
      }
      .footer-heading {
          letter-spacing: 2px;
      }
      .footer-link a {
          color: #ffffff;
          font-size: 14px;
          transition: all 0.2s;
          text-decoration: none;
      }
      .footer-link a:hover {
          color: #FDC031;
          text-decoration: none;
      }
      .contact-info {
          color: #ffffff;
          font-size: 14px;
      }
      .footer-alt {
          color: #818282;
          font-size: 12px;
      }
      .footer-heading {
          position: relative;
          padding-bottom: -12px !important;
      }
      .footer-heading:after {
          content: '';
          width: 25px;
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
      }
      .contact-info-icon {
          color: #ffffff;
          font-size: 16px;
      }
      .contact-info-data {
          color: #ffffff;
          font-size: 16px;
          margin: 0px 0px 0px !important;
      }
      /* Extra small devices (phones, 600px and down) */
      @media  only screen and (max-width: 648px) {
          .footer-download-icon {
              width: 36%;
          }
          .banner_img{
         display: none;
      }
      }
      /* Small devices (portrait tablets and large phones, 600px and up) */
      @media  only screen and (min-width: 648px) {
          .footer-download-icon {
              width: 36%;
          }
          .carousel-content {
    transition: width .4s;
    height: 80%;
  }
  
      }
      /* Medium devices (landscape tablets, 768px and up) */
      @media  only screen and (min-width: 768px) {
          .footer-download-icon {
              width: 40%;
          }
          .carousel-content {
    transition: width .4s;
    height: 80%;
  }
         
      }
      /* Large devices (laptops/desktops, 992px and up) */
      @media  only screen and (min-width: 992px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
          transition: width .4s;
          height: 60%;
        }
 
      }
      /* Extra large devices (large laptops and desktops, 1200px and up) */
      @media  only screen and (min-width: 1200px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
    transition: width .4s;
    height: 60%;
  }
 
      }
      .footer-get-trial-button {
          background: #FDC031;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 6px;
          padding-bottom: 6px;
          font-weight: bold;
          border-radius: 4px;
          border: none;
          color: #333;
          text-align: center;
          margin-top: 10px;
          font-weight: 500;
          transition: all 0.5s;
          cursor: pointer;
      }
      .footer-hr {
          border-color: #404447;
          background-color: #404447;
          color: #404447;
      }
      .below-hr-container {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a:hover {
          text-decoration: none;
      }
  /* footer css end */

</style>